module.exports = __webpack_public_path__ + "img/carnAction.206ea0ac.png";